/* SPH – mobiles Menü: Shop-Block zuverlässig einhängen, Akkordeon geschlossen starten */
(function () {
  if (window.matchMedia('(min-width: 991px)').matches) return;

  function closeAll() {
    var host = document.querySelector('header-drawer');
    if (!host) return;
    host.querySelectorAll('accordion-custom > details[open]').forEach(function (d) {
      d.removeAttribute('open');
      var s = d.querySelector('summary');
      if (s) s.setAttribute('aria-expanded', 'false');
    });
  }

  function mount() {
    var drawer = document.querySelector('header-drawer .menu-drawer');
    var tpl = document.getElementById('sph-drawer-extra');
    if (!drawer || !tpl) return false;
    if (drawer.querySelector('.sph-dx')) return true;
    drawer.appendChild(tpl.content.cloneNode(true));
    return true;
  }

  /* mehrfach versuchen, bis das Drawer-Markup wirklich da ist */
  function mountWithRetry(tries) {
    if (mount()) return;
    if (tries <= 0) return;
    setTimeout(function () { mountWithRetry(tries - 1); }, 150);
  }

  function init() {
    mountWithRetry(20);
    closeAll();

    var root = document.querySelector('#header-group');
    if (root) {
      new MutationObserver(function () { mount(); }).observe(root, { childList: true, subtree: true });
    }

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('button[aria-controls*="drawer" i]');
      if (!opener || e.target.closest('header-drawer .menu-drawer')) return;
      mountWithRetry(20);
      setTimeout(closeAll, 80);
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', function () { mountWithRetry(10); });
})();
